import axios from 'axios';

export const getManifest = async () => {
    const { data } = await axios.get('/manifest.json');
    return data;
};
